import { defineComponent as _defineComponent } from 'vue'
import { ref, PropType } from 'vue';
import ListDownloadButton from './ListDownloadButton.vue';
import { PaginatedResponse, PaginatedQuery } from 'ah-api-gateways';
import { RequestState } from 'ah-requests';
import PaginationControls from './PaginationControls.vue';
/**
 * Importing table component as BaseDynamicTable so the <DynamicTable> component in template loads the globally defined component
 * (which will be the app-specific table component)
 */
import BaseDynamicTable, { commonTableProps } from './DynamicTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginatedTable',
  props: {
  data: {
    type: Object as PropType<PaginatedResponse<{ [key: string]: any }> | null>,
    default: null,
  },
  query: {
    type: Object as PropType<PaginatedQuery | null>,
    default: null,
  },
  dataDownloadState: {
    type: String as PropType<RequestState>,
    default: 'idle',
  },
  showExport: {
    type: [Boolean, String],
    default: false,
  },
  showTableFooterTotals: {
    type: [Boolean, String],
    default: true,
  },
  hidePagination: {
    type: [Boolean, String],
    default: false,
  },
  ...commonTableProps,
},
  emits: {
  sort: (_model: PaginatedQuery) => true,
},
  setup(__props, { expose, emit }) {

const props = __props;

const table = ref<InstanceType<typeof BaseDynamicTable>>();





function setPage(pageNumber: any) {
  emit('sort', {
    ...props.query,
    pageNumber,
  } as PaginatedQuery);
}

expose({ table: table });

return { __sfc: true,table, props, emit, setPage, ListDownloadButton, PaginationControls }
}

})